export const CDN_PATH = 'https://d12xoj7p9moygp.cloudfront.net/images';
export interface localeCodeMapping {
  [key: string]: string;
}
